// hooks/useGenericExport.js
import { useCallback, useState } from "react";
import axios from "axios"; // or your configured api instance

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const triggerDownload = (blob, fallbackName) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const useExport = () => {
  const [exporting, setExporting] = useState(false);
  const [exportError, setExportError] = useState(null);

  const runExport = useCallback(async (endpoint, payload, fallbackName) => {
    setExporting(true);
    setExportError(null);
    try {
      const res = await axios.post(
        `${BASE_URL}/api/export/${endpoint}`,
        payload,
        {
          responseType: "blob",
        },
      );
      triggerDownload(res.data, fallbackName);
    } catch (err) {
      // error responses come back as blob too — decode the JSON message
      let msg = "Export failed";
      if (err?.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text();
          msg = JSON.parse(text)?.message || msg;
        } catch {
          /* keep default */
        }
      }
      setExportError(msg);
      console.error("Export failed:", msg);
    } finally {
      setExporting(false);
    }
  }, []);

  const exportCSV = useCallback(
    ({ rows, columns, filename, sheetName }) =>
      runExport(
        "csv",
        { rows, columns, filename, sheetName },
        `${filename}.csv`,
      ),
    [runExport],
  );

  const exportExcel = useCallback(
    ({ rows, columns, filename, sheetName }) =>
      runExport(
        "excel",
        { rows, columns, filename, sheetName },
        `${filename}.xlsx`,
      ),
    [runExport],
  );

  return { exportCSV, exportExcel, exporting, exportError };
};
